import {
  DetailsCellSkeleton,
  Relative,
  SubheaderSkeleton,
  VStack,
} from '@revolut-internal/ui-kit'
import { FC } from 'react'

export const DebugDetailsLoading: FC = () => {
  return (
    <>
      <VStack px="s-16" pt="s-16">
        <SubheaderSkeleton />
      </VStack>

      <Relative height="100%">
        <VStack height="100%" p="s-16" space="s-16">
          <DetailsCellSkeleton />
          <DetailsCellSkeleton />
          <DetailsCellSkeleton />
          <DetailsCellSkeleton />
          <DetailsCellSkeleton />
          <DetailsCellSkeleton />
          <DetailsCellSkeleton />
          <DetailsCellSkeleton />
          <DetailsCellSkeleton />
          <DetailsCellSkeleton />
        </VStack>
      </Relative>
    </>
  )
}
